import React from "react";
import { useAuthContext } from "../../contexts/AuthContext";
import { Link } from "react-router-dom";
import { useLanguage } from "../../contexts/LanguageContext";

const UserPanel: React.FC = () => {
  const { user, profile, gameData, logout } = useAuthContext();
  const { t } = useLanguage();

  const defaultUser = { username: "Invitado" };
  const safeUser = user ?? defaultUser;

  const defaultProfile = { firstName: safeUser.username };
  const safeProfile = profile ?? defaultProfile;

  const defaultGameData = { level: 1, gold: 100, class: "Aprendiz" };
  const safeGameData = gameData ?? defaultGameData;

  return (
    <div className="user-panel">
      <div className="user-header">
        <i className="fas fa-user-circle user-avatar"></i>
        <h3>
          {t("common", "AuthSidebar.welcome")},{" "}
          <span id="usernameDisplay">{safeUser.username}</span>!
        </h3>
      </div>

      <div className="user-info">
        <div className="info-item">
          <i className="fas fa-trophy"></i>
          <span>
            {t("auth", "userPanel.name")}:{" "}
            <strong id="userFirstName">{safeProfile.firstName}</strong>
          </span>
        </div>
        <div className="info-item">
          <i className="fas fa-trophy"></i>
          <span>
            {t("auth", "userPanel.level")}:{" "}
            <strong id="userLevel">{safeGameData.level}</strong>
          </span>
        </div>
        <div className="info-item">
          <i className="fas fa-coins"></i>
          <span>
            {t("auth", "userPanel.gold")}:{" "}
            <strong id="userGold">{safeGameData.gold}</strong>
          </span>
        </div>
        <div className="info-item">
          <i className="fas fa-shield-alt"></i>
          <span>
            {t("auth", "userPanel.class")}:{" "}
            <strong id="userClass">{safeGameData.class}</strong>
          </span>
        </div>
      </div>

      <div className="user-actions">
        <button className="action-btn primary">
          <Link to="/download">
            <i className="fas fa-play"></i> {t("common", "buttons.play")}
          </Link>
        </button>
        <button className="action-btn secondary" onClick={logout}>
          <i className="fas fa-sign-out-alt"></i>{" "}
          {t("common", "buttons.logout")}
        </button>
      </div>
    </div>
  );
};

export default UserPanel;
